import { FormEvent, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

const QUICK_LINKS = [
  { to: '/', label: '首页' },
  { to: '/movies', label: '电影分类' },
  { to: '/tvshows', label: '电视剧分类' },
  { to: '/search', label: '搜索影视' },
  { to: '/about', label: '关于我们' },
];

const GENRE_LINKS = ['科幻', '悬疑', '动作', '爱情', '古装', '喜剧'];

export default function Footer() {
  const navigate = useNavigate();
  const [keyword, setKeyword] = useState('');

  const submit = (event: FormEvent) => {
    event.preventDefault();
    const kw = keyword.trim();
    navigate(kw ? `/search?q=${encodeURIComponent(kw)}` : '/search');
    setKeyword('');
  };

  return (
    <footer className="mt-20 bg-primary-950 text-background-200">
      <div className="mx-auto max-w-[1280px] px-4 py-12 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2.5">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-accent-500">
                <i className="ri-movie-2-line text-xl text-primary-950" />
              </span>
              <span className="font-heading text-xl font-extrabold text-background-50">星辰影院</span>
            </div>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-background-300">
              星辰影院致力于为影迷提供最新、最热门的电影与电视剧浏览入口，涵盖多种类型与地区，帮你快速找到想看的影视作品。
            </p>
            <div className="mt-5 flex items-center gap-3">
              {['ri-weibo-line', 'ri-wechat-line', 'ri-bilibili-line', 'ri-mail-line'].map((icon) => (
                <span
                  key={icon}
                  className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-full bg-primary-900 text-background-200 transition-colors hover:bg-accent-500 hover:text-primary-950"
                >
                  <i className={`${icon} text-lg`} />
                </span>
              ))}
            </div>
          </div>

          <div>
            <h3 className="text-sm font-semibold uppercase tracking-wider text-background-50">快速导航</h3>
            <ul className="mt-4 space-y-2.5">
              {QUICK_LINKS.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-background-300 transition-colors hover:text-accent-300"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold uppercase tracking-wider text-background-50">热门类型</h3>
            <ul className="mt-4 space-y-2.5">
              {GENRE_LINKS.map((genre) => (
                <li key={genre}>
                  <Link
                    to={`/search?q=${encodeURIComponent(genre)}`}
                    className="text-sm text-background-300 transition-colors hover:text-accent-300"
                  >
                    {genre}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold uppercase tracking-wider text-background-50">影视速搜</h3>
            <p className="mt-4 text-sm text-background-300">输入片名或关键词，快速进入搜索结果。</p>
            <form onSubmit={submit} className="mt-4">
              <div className="flex items-center gap-2 rounded-full border border-primary-800 bg-primary-900 px-4 py-2.5">
                <span className="flex h-5 w-5 items-center justify-center text-background-300">
                  <i className="ri-search-line text-base" />
                </span>
                <input
                  type="text"
                  value={keyword}
                  onChange={(e) => setKeyword(e.target.value)}
                  placeholder="如：星际、悬疑"
                  className="w-full bg-transparent text-sm text-background-50 outline-none placeholder:text-background-400"
                />
              </div>
              <button
                type="submit"
                className="mt-3 w-full cursor-pointer whitespace-nowrap rounded-full bg-accent-500 px-5 py-2.5 text-sm font-semibold text-primary-950 transition-colors hover:bg-accent-400"
              >
                立即搜索
              </button>
            </form>
          </div>
        </div>
      </div>

      <div className="border-t border-primary-800/70">
        <div className="mx-auto flex max-w-[1280px] flex-col items-center justify-between gap-3 px-4 py-6 text-xs text-background-400 md:flex-row md:px-8">
          <p>© {new Date().getFullYear()} 星辰影院 · 最新电影电视剧在线观看平台</p>
          <p className="text-center md:text-right">
            本站为演示站点，所有影视作品及数据均为示例内容，不提供真实播放服务。
          </p>
        </div>
      </div>
    </footer>
  );
}